var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 21.25H22.5V17.5L28.75 23.125L22.5 28.75V25H17.5V21.25ZM16.25 11.25H23.125L16.25 4.375V11.25ZM7.5 2.5H17.5L25 10V15.425C24.2125 15.15 23.375 15 22.5 15C20.5109 15 18.6032 15.7901 17.1967 17.1967C15.7901 18.6032 15 20.5109 15 22.5C15 24.425 15.725 26.175 16.9125 27.5H7.5C6.83696 27.5 6.20108 27.2366 5.73224 26.7677C5.26339 26.2989 5 25.663 5 25V5C5 4.33696 5.26339 3.70107 5.73224 3.23224C6.20108 2.76339 6.83696 2.5 7.5 2.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveicon);
export default __webpack_public_path__ + "static/media/moveicon.22bb93eef629d668bd7718dffc18e75e.svg";
export { ForwardRef as ReactComponent };